//utility for components that support 'elements_extra'

export function getElementsHandleExtra({ elements = {}, elements_extra = {} }) {
	const elementKeys = Object.keys(elements);
	const extraKeys = Object.keys(elements_extra);

	if (elementKeys.length > 0) {
		if (extraKeys.length > 0) {
			return [...elementKeys, ...extraKeys].reduce((all, currentKey, index) => {
				if (elementKeys.length > index) {
					all[index] = elements[currentKey];
				} else if (!elements_extra[currentKey]?.linkedLabel) {
					//extra element
					all[index] = elements_extra[currentKey];
				}

				return all;
			}, {});
		}
		return elements;
	}

	return {};
}
